// import React, { useState } from 'react';
// import Grid from "@material-ui/core/Grid";
// import TextField from "@material-ui/core/TextField";
// import Button from "@material-ui/core/Button";
// import FormControl from "@material-ui/core/FormControl";
// import Select from "@material-ui/core/Select";
// import MenuItem from "@material-ui/core/MenuItem";
// import { toast } from "react-toastify";
// import SimpleReactValidator from "simple-react-validator";
// import {
//     sendBrokerRegistration,
//     rateLimiter,
//     handleApiError,
//     getSuccessMessage
// } from '../../utils/api';

// const AgentRegistrationForm = ({ onPrevious }) => {
//     const [step, setStep] = useState(1);
//     const [validator] = useState(new SimpleReactValidator({
//         className: 'error-message'
//     }));

//     const [formData, setFormData] = useState({
//         // Personal Details
//         fullName: '',
//         email: '',
//         phoneNumber: '',
//         whatsappNumber: '',
//         dateOfBirth: '',
//         nationality: '',
//         gender: '',

//         // Professional Details
//         experience: '',
//         specialization: '',
//         languages: '',
//         currentCompany: '',
//         reraNumber: '',

//         // Document Details
//         passport: null,
//         resume: null,
//         reraLicense: null,
//         otherDocuments: null
//     });

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData({
//             ...formData,
//             [name]: value
//         });
//         validator.showMessages();
//     };

//     const handleFileChange = (e) => {
//         const { name, files } = e.target;
//         setFormData({
//             ...formData,
//             [name]: files[0]
//         });
//     };

//     const handleNext = () => {
//         if (step === 1) {
//             if (validator.fieldValid('fullName') &&
//                 validator.fieldValid('email') &&
//                 validator.fieldValid('phoneNumber') &&
//                 validator.fieldValid('whatsappNumber') &&
//                 validator.fieldValid('nationality')) {
//                 setStep(2);
//             } else {
//                 validator.showMessages();
//                 toast.error('Please fill all required fields!');
//             }
//         } else if (step === 2) {
//             if (validator.fieldValid('experience')) {
//                 setStep(3);
//             } else {
//                 validator.showMessages();
//                 toast.error('Please fill all required fields!');
//             }
//         }
//     };

//     const handlePrevious = () => {
//         if (step > 1) {
//             setStep(step - 1);
//         } else {
//             onPrevious();
//         }
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (!validator.allValid()) {
//             validator.showMessages();
//             toast.error('Please fill all required fields!');
//             return;
//         }

//         // Check if required documents are uploaded
//         if (!formData.passport || !formData.resume) {
//             toast.error('Please upload required documents (Passport and Resume/CV)');
//             return;
//         }

//         // Check rate limiting
//         if (!rateLimiter.canMakeRequest('/api/send-broker-registration')) {
//             toast.error('Too many requests. Please wait a moment and try again.');
//             return;
//         }

//         try {
//             // Prepare form data for API with all details including files
//             const apiFormData = {
//                 name: formData.fullName,
//                 email: formData.email,
//                 phone: formData.phoneNumber,
//                 registrationType: 'individual',
//                 whatsappNumber: formData.whatsappNumber,
//                 dateOfBirth: formData.dateOfBirth,
//                 nationality: formData.nationality,
//                 gender: formData.gender,
//                 experience: formData.experience,
//                 specialization: formData.specialization,
//                 languages: formData.languages,
//                 currentCompany: formData.currentCompany,
//                 reraNumber: formData.reraNumber,
//                 company: formData.currentCompany || 'Individual Agent',
//                 licenseNumber: formData.reraNumber,
//                 address: `${formData.nationality} - ${formData.gender || 'Not specified'}`,
//                 message: `Specialization: ${formData.specialization || 'Not specified'}\nLanguages: ${formData.languages || 'Not specified'}`,

//                 // Document files
//                 passport: formData.passport,
//                 resume: formData.resume,
//                 reraLicense: formData.reraLicense,
//                 otherDocuments: formData.otherDocuments
//             };

//             // Send broker registration via API
//             const response = await sendBrokerRegistration(apiFormData);

//             if (response.success) {
//                 toast.success(getSuccessMessage('broker'));

//                 // Reset form or redirect
//                 // You can add navigation logic here if needed
//             } else {
//                 throw new Error(response.message || 'Failed to submit registration');
//             }
//         } catch (error) {
//             const errorMessage = handleApiError(error, 'broker');
//             toast.error(errorMessage);
//         }
//     };

//     return (
//         <div className="agent-registration-form">
//             <div className="form-header">
//                 <h2>Individual Registration</h2>
//                 <p>Complete your profile to start your career in real estate with MaakDream Developers</p>
//             </div>

//             <form onSubmit={handleSubmit}>
//                 {step === 1 && (
//                     <div className="form-step">
//                         <div className="step-header">
//                             <div className="step-number">1</div>
//                             <h3>Personal Information</h3>
//                         </div>

//                         <div className="form-container">
//                             <Grid container spacing={3}>
//                                 <Grid item xs={12}>
//                                     <div className="form-field">
//                                         <label className="required">Full Name</label>
//                                         <TextField
//                                             fullWidth
//                                             name="fullName"
//                                             value={formData.fullName}
//                                             onChange={handleChange}
//                                             variant="outlined"
//                                             required
//                                             InputProps={{
//                                                 placeholder: "Enter your full name as per passport"
//                                             }}
//                                         />
//                                         {validator.message('fullName', formData.fullName, 'required')}
//                                     </div>
//                                 </Grid>
//                                 <Grid item xs={12} md={6}>
//                                     <div className="form-field">
//                                         <label className="required">Email Address</label>
//                                         <TextField
//                                             fullWidth
//                                             name="email"
//                                             type="email"
//                                             value={formData.email}
//                                             onChange={handleChange}
//                                             variant="outlined"
//                                             required
//                                             InputProps={{
//                                                 placeholder: "your.email@example.com"
//                                             }}
//                                         />
//                                         {validator.message('email', formData.email, 'required|email')}
//                                     </div>
//                                 </Grid>
//                                 <Grid item xs={12} md={6}>
//                                     <div className="form-field">
//                                         <label className="required">Phone Number</label>
//                                         <TextField
//                                             fullWidth
//                                             name="phoneNumber"
//                                             value={formData.phoneNumber}
//                                             onChange={handleChange}
//                                             variant="outlined"
//                                             required
//                                             InputProps={{
//                                                 placeholder: "+971 XX XXX XXXX"
//                                             }}
//                                         />
//                                         {validator.message('phoneNumber', formData.phoneNumber, 'required')}
//                                     </div>
//                                 </Grid>
//                                 <Grid item xs={12} md={6}>
//                                     <div className="form-field">
//                                         <label className="required">WhatsApp Number</label>
//                                         <TextField
//                                             fullWidth
//                                             name="whatsappNumber"
//                                             value={formData.whatsappNumber}
//                                             onChange={handleChange}
//                                             variant="outlined"
//                                             required
//                                             InputProps={{
//                                                 placeholder: "+971 XX XXX XXXX"
//                                             }}
//                                         />
//                                         {validator.message('whatsappNumber', formData.whatsappNumber, 'required')}
//                                     </div>
//                                 </Grid>
//                                 <Grid item xs={12} md={6}>
//                                     <div className="form-field">
//                                         <label>Date of Birth</label>
//                                         <TextField
//                                             fullWidth
//                                             name="dateOfBirth"
//                                             type="date"
//                                             value={formData.dateOfBirth}
//                                             onChange={handleChange}
//                                             variant="outlined"
//                                         />
//                                     </div>
//                                 </Grid>
//                                 <Grid item xs={12} md={6}>
//                                     <div className="form-field">
//                                         <label className="required">Nationality</label>
//                                         <FormControl variant="outlined" fullWidth required>
//                                             <Select
//                                                 name="nationality"
//                                                 value={formData.nationality}
//                                                 onChange={handleChange}
//                                                 displayEmpty
//                                             >
//                                                 <MenuItem value="">
//                                                     <em>--Select Nationality--</em>
//                                                 </MenuItem>
//                                                 <MenuItem value="UAE">UAE</MenuItem>
//                                                 <MenuItem value="India">India</MenuItem>
//                                                 <MenuItem value="Pakistan">Pakistan</MenuItem>
//                                                 <MenuItem value="UK">United Kingdom</MenuItem>
//                                                 <MenuItem value="USA">United States</MenuItem>
//                                                 <MenuItem value="Other">Other</MenuItem>
//                                             </Select>
//                                         </FormControl>
//                                         {validator.message('nationality', formData.nationality, 'required')}
//                                     </div>
//                                 </Grid>
//                                 <Grid item xs={12} md={6}>
//                                     <div className="form-field">
//                                         <label>Gender</label>
//                                         <FormControl variant="outlined" fullWidth>
//                                             <Select
//                                                 name="gender"
//                                                 value={formData.gender}
//                                                 onChange={handleChange}
//                                                 displayEmpty
//                                             >
//                                                 <MenuItem value="">
//                                                     <em>--Select Gender--</em>
//                                                 </MenuItem>
//                                                 <MenuItem value="Male">Male</MenuItem>
//                                                 <MenuItem value="Female">Female</MenuItem>
//                                                 <MenuItem value="Other">Other</MenuItem>
//                                             </Select>
//                                         </FormControl>
//                                     </div>
//                                 </Grid>
//                             </Grid>
//                         </div>
//                     </div>
//                 )}

//                 {step === 2 && (
//                     <div className="form-step">
//                         <div className="step-header">
//                             <div className="step-number">2</div>
//                             <h3>Professional Information</h3>
//                         </div>

//                         <div className="form-container">
//                             <Grid container spacing={3}>
//                                 <Grid item xs={12} md={6}>
//                                     <div className="form-field">
//                                         <label className="required">Years of Experience</label>
//                                         <TextField
//                                             fullWidth
//                                             name="experience"
//                                             type="number"
//                                             value={formData.experience}
//                                             onChange={handleChange}
//                                             variant="outlined"
//                                             required
//                                             InputProps={{
//                                                 placeholder: "e.g., 5"
//                                             }}
//                                         />
//                                         {validator.message('experience', formData.experience, 'required')}
//                                     </div>
//                                 </Grid>
//                                 <Grid item xs={12} md={6}>
//                                     <div className="form-field">
//                                         <label>Specialization</label>
//                                         <FormControl variant="outlined" fullWidth>
//                                             <Select
//                                                 name="specialization"
//                                                 value={formData.specialization}
//                                                 onChange={handleChange}
//                                                 displayEmpty
//                                             >
//                                                 <MenuItem value="">
//                                                     <em>--Select Specialization--</em>
//                                                 </MenuItem>
//                                                 <MenuItem value="Residential">Residential</MenuItem>
//                                                 <MenuItem value="Commercial">Commercial</MenuItem>
//                                                 <MenuItem value="Luxury">Luxury Properties</MenuItem>
//                                                 <MenuItem value="Off-Plan">Off-Plan Projects</MenuItem>
//                                                 <MenuItem value="All">All Property Types</MenuItem>
//                                             </Select>
//                                         </FormControl>
//                                     </div>
//                                 </Grid>
//                                 <Grid item xs={12}>
//                                     <div className="form-field">
//                                         <label>Languages Spoken</label>
//                                         <TextField
//                                             fullWidth
//                                             name="languages"
//                                             value={formData.languages}
//                                             onChange={handleChange}
//                                             variant="outlined"
//                                             placeholder="e.g., English, Arabic, Hindi, Urdu"
//                                             InputProps={{
//                                                 placeholder: "e.g., English, Arabic, Hindi, Urdu"
//                                             }}
//                                         />
//                                     </div>
//                                 </Grid>
//                                 <Grid item xs={12} md={6}>
//                                     <div className="form-field">
//                                         <label>Current Company (if any)</label>
//                                         <TextField
//                                             fullWidth
//                                             name="currentCompany"
//                                             value={formData.currentCompany}
//                                             onChange={handleChange}
//                                             variant="outlined"
//                                             InputProps={{
//                                                 placeholder: "Company name or 'Freelance'"
//                                             }}
//                                         />
//                                     </div>
//                                 </Grid>
//                                 <Grid item xs={12} md={6}>
//                                     <div className="form-field">
//                                         <label>RERA Number (if any)</label>
//                                         <TextField
//                                             fullWidth
//                                             name="reraNumber"
//                                             value={formData.reraNumber}
//                                             onChange={handleChange}
//                                             variant="outlined"
//                                             InputProps={{
//                                                 placeholder: "RERA license number"
//                                             }}
//                                         />
//                                     </div>
//                                 </Grid>
//                             </Grid>
//                         </div>
//                     </div>
//                 )}

//                 {step === 3 && (
//                     <div className="form-step">
//                         <div className="step-header">
//                             <div className="step-number">3</div>
//                             <h3>Required Documents</h3>
//                         </div>

//                         <div className="form-container">
//                             <div className="document-upload">
//                                 <div className="document-upload-item">
//                                     <label>Passport Copy <span className="required-field">*</span></label>
//                                     <p className="document-help">Upload a clear copy of your passport's main page</p>
//                                     <div className="upload-btn-wrapper">
//                                         <div className="upload-btn">
//                                             {formData.passport ? formData.passport.name : 'Choose file...'}
//                                         </div>
//                                         <input
//                                             type="file"
//                                             name="passport"
//                                             onChange={handleFileChange}
//                                             accept=".pdf,.jpg,.jpeg,.png"
//                                         />
//                                     </div>
//                                 </div>

//                                 <div className="document-upload-item">
//                                     <label>Resume/CV <span className="required-field">*</span></label>
//                                     <p className="document-help">Upload your updated resume or CV in PDF or Word format</p>
//                                     <div className="upload-btn-wrapper">
//                                         <div className="upload-btn">
//                                             {formData.resume ? formData.resume.name : 'Choose file...'}
//                                         </div>
//                                         <input
//                                             type="file"
//                                             name="resume"
//                                             onChange={handleFileChange}
//                                             accept=".pdf,.doc,.docx"
//                                         />
//                                     </div>
//                                 </div>

//                                 <div className="document-upload-item">
//                                     <label>RERA License (if available)</label>
//                                     <p className="document-help">Upload your RERA license if you already have one</p>
//                                     <div className="upload-btn-wrapper">
//                                         <div className="upload-btn">
//                                             {formData.reraLicense ? formData.reraLicense.name : 'Choose file...'}
//                                         </div>
//                                         <input
//                                             type="file"
//                                             name="reraLicense"
//                                             onChange={handleFileChange}
//                                             accept=".pdf,.jpg,.jpeg,.png"
//                                         />
//                                     </div>
//                                 </div>

//                                 <div className="document-upload-item">
//                                     <label>Other Supporting Documents</label>
//                                     <p className="document-help">Upload any additional certificates, references, or supporting documents</p>
//                                     <div className="upload-btn-wrapper">
//                                         <div className="upload-btn">
//                                             {formData.otherDocuments ? formData.otherDocuments.name : 'Choose file...'}
//                                         </div>
//                                         <input
//                                             type="file"
//                                             name="otherDocuments"
//                                             onChange={handleFileChange}
//                                             accept=".pdf,.jpg,.jpeg,.png,.zip"
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 )}

//                 <div className="form-navigation">
//                     <Button
//                         className="cBtn cBtnLarge"
//                         onClick={handlePrevious}
//                     >
//                         <i className="fi ti-arrow-left"></i>
//                         Previous
//                     </Button>

//                     {step < 3 ? (
//                         <Button
//                             className="cBtn cBtnLarge cBtnTheme"
//                             onClick={handleNext}
//                         >
//                             Next Step
//                             <i className="fi ti-arrow-right"></i>
//                         </Button>
//                     ) : (
//                         <Button
//                             className="cBtn cBtnLarge cBtnTheme"
//                             type="submit"
//                         >
//                             <i className="fi flaticon-check"></i>
//                             Submit Registration
//                         </Button>
//                     )}
//                 </div>
//             </form>
//         </div>
//     );
// };

// export default AgentRegistrationForm;
































































import React, { useState, useEffect } from 'react';
import { getBR3 } from '../../api/BrokerRegistration'; // import your service
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { toast } from "react-toastify";
import SimpleReactValidator from "simple-react-validator";
import {
    sendBrokerRegistration,
    rateLimiter,
    handleApiError,
    getSuccessMessage,
    sendIndividualBrokerRegistration
} from '../../utils/api';

const AgentRegistrationForm = ({ onPrevious }) => {
    const [step, setStep] = useState(1);
    const [validator] = useState(new SimpleReactValidator({ className: 'error-message' }));
    const [isRegistering, setIsRegistering] = useState(false);
    // State for form fields
    const [formData, setFormData] = useState({
        fullName: '', email: '', phoneNumber: '', whatsappNumber: '', dateOfBirth: '',
        nationality: '', gender: '', experience: '', specialization: '', languages: '',
        currentCompany: '', reraNumber: '', passport: null, 
        reraLicense: null, otherDocuments: null,
        // resume: null,
    });

    // State for dynamic heading/subheading
    const [br3Data, setBr3Data] = useState({ heading: '', subheading: '' });

    // Fetch BR3 data on mount
    useEffect(() => {
        const fetchBR3 = async () => {
            const data = await getBR3();
            if (data) {
                setBr3Data({ heading: data.heading, subheading: data.subheading });
            }
        };
        fetchBR3();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        validator.showMessages();
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData({ ...formData, [name]: files[0] });
    };

    const handleNext = () => {
        if (step === 1) {
            if (validator.fieldValid('fullName') &&
                validator.fieldValid('email') &&
                validator.fieldValid('phoneNumber') &&
                validator.fieldValid('whatsappNumber') &&
                validator.fieldValid('nationality')) {
                setStep(2);
            } else {
                validator.showMessages();
                toast.error('Please fill all required fields!');
            }
        } else if (step === 2) {
            if (validator.fieldValid('experience')) {
                setStep(3);
            } else {
                validator.showMessages();
                toast.error('Please fill all required fields!');
            }
        }
    };

    const handlePrevious = () => {
        if (step > 1) setStep(step - 1);
        else onPrevious();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate all fields first
        if (!validator.allValid()) {
            validator.showMessages();
            toast.error('Please fill all required fields!');
            return;
        }

        // Check required documents

        if (!formData.passport ) {//|| !formData.resume
            toast.error('Please upload required documents (Passport )');
            return;
        }

        // Set loading state
        setIsRegistering(true);

        try {
            // Build raw object (NOT FormData — sendIndividualBrokerRegistration will handle FormData)
            const apiFormData = {
                full_name: formData.fullName,
                email: formData.email,
                phone_number: formData.phoneNumber,
                whatsapp_number: formData.whatsappNumber,
                date_of_birth: formData.dateOfBirth,
                nationality: formData.nationality,
                gender: formData.gender,
                years_of_experience: formData.experience,
                specialization: formData.specialization,
                languages_spoken: formData.languages,
                current_company: formData.currentCompany,
                rera_number: formData.reraNumber,

                // Files
                passport_copy: formData.passport,
                // resume_cv: formData.resume,
                rera_license: formData.reraLicense,
                other_supporting_documents: formData.otherDocuments
            };

            const response = await sendIndividualBrokerRegistration(apiFormData);

            if (response.success) {
                toast.success(getSuccessMessage('broker'));
                // Optional: Reset form or redirect user here
                // setFormData({ ...initial state });
                // setStep(1);
            } else {
                throw new Error(response.message || 'Failed to submit registration');
            }
        } catch (error) {
            toast.error(handleApiError(error, 'broker'));
        } finally {
            // ALWAYS reset loading state in finally block
            setIsRegistering(false);
        }
    };

    return (
        <div className="agent-registration-form">
            <div className="form-header">
                <h2>{br3Data.heading || 'Individual Registration'}</h2>
                <p>{br3Data.subheading || 'Complete your profile to start your career in real estate with MaakDream Developers'}</p>
            </div>
            <form onSubmit={handleSubmit} onKeyDown={(e) => {
                if (e.key === "Enter") {
                    e.preventDefault();   // Prevent enter submit
                }
            }}>
                {step === 1 && (
                    <div className="form-step">
                        <div className="step-header">
                            <div className="step-number">1</div>
                            <h3>Personal Information</h3>
                        </div>

                        <div className="form-container">
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <div className="form-field">
                                        <label className="required">Full Name</label>
                                        <TextField
                                            fullWidth
                                            name="fullName"
                                            value={formData.fullName}
                                            onChange={handleChange}
                                            variant="outlined"
                                            required
                                            InputProps={{
                                                placeholder: "Enter your full name as per passport"
                                            }}
                                        />
                                        {validator.message('fullName', formData.fullName, 'required')}
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="form-field">
                                        <label className="required">Email Address</label>
                                        <TextField
                                            fullWidth
                                            name="email"
                                            type="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            variant="outlined"
                                            required
                                            InputProps={{
                                                placeholder: "your.email@example.com"
                                            }}
                                        />
                                        {validator.message('email', formData.email, 'required|email')}
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="form-field">
                                        <label className="required">Phone Number</label>
                                        <TextField
                                            fullWidth
                                            name="phoneNumber"
                                            value={formData.phoneNumber}
                                            onChange={handleChange}
                                            variant="outlined"
                                            required
                                            InputProps={{
                                                placeholder: "+971 XX XXX XXXX"
                                            }}
                                        />
                                        {validator.message('phoneNumber', formData.phoneNumber, 'required')}
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="form-field">
                                        <label className="required">WhatsApp Number</label>
                                        <TextField
                                            fullWidth
                                            name="whatsappNumber"
                                            value={formData.whatsappNumber}
                                            onChange={handleChange}
                                            variant="outlined"
                                            required
                                            InputProps={{
                                                placeholder: "+971 XX XXX XXXX"
                                            }}
                                        />
                                        {validator.message('whatsappNumber', formData.whatsappNumber, 'required')}
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="form-field">
                                        <label>Date of Birth</label>
                                        <TextField
                                            fullWidth
                                            name="dateOfBirth"
                                            type="date"
                                            value={formData.dateOfBirth}
                                            onChange={handleChange}
                                            variant="outlined"
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="form-field">
                                        <label className="required">Nationality</label>
                                        <FormControl variant="outlined" fullWidth required>
                                            <Select
                                                name="nationality"
                                                value={formData.nationality}
                                                onChange={handleChange}
                                                displayEmpty
                                            >
                                                <MenuItem value="">
                                                    <em>--Select Nationality--</em>
                                                </MenuItem>
                                                <MenuItem value="UAE">UAE</MenuItem>
                                                <MenuItem value="India">India</MenuItem>
                                                <MenuItem value="Pakistan">Pakistan</MenuItem>
                                                <MenuItem value="UK">United Kingdom</MenuItem>
                                                <MenuItem value="USA">United States</MenuItem>
                                                <MenuItem value="Other">Other</MenuItem>
                                            </Select>
                                        </FormControl>
                                        {validator.message('nationality', formData.nationality, 'required')}
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="form-field">
                                        <label>Gender</label>
                                        <FormControl variant="outlined" fullWidth>
                                            <Select
                                                name="gender"
                                                value={formData.gender}
                                                onChange={handleChange}
                                                displayEmpty
                                            >
                                                <MenuItem value="">
                                                    <em>--Select Gender--</em>
                                                </MenuItem>
                                                <MenuItem value="Male">Male</MenuItem>
                                                <MenuItem value="Female">Female</MenuItem>
                                                <MenuItem value="Other">Other</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                )}

                {step === 2 && (
                    <div className="form-step">
                        <div className="step-header">
                            <div className="step-number">2</div>
                            <h3>Professional Information</h3>
                        </div>

                        <div className="form-container">
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <div className="form-field">
                                        <label className="required">Years of Experience</label>
                                        <TextField
                                            fullWidth
                                            name="experience"
                                            type="number"
                                            value={formData.experience}
                                            onChange={handleChange}
                                            variant="outlined"
                                            required
                                            InputProps={{
                                                placeholder: "e.g., 5"
                                            }}
                                        />
                                        {validator.message('experience', formData.experience, 'required')}
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="form-field">
                                        <label>Specialization</label>
                                        <FormControl variant="outlined" fullWidth>
                                            <Select
                                                name="specialization"
                                                value={formData.specialization}
                                                onChange={handleChange}
                                                displayEmpty
                                            >
                                                <MenuItem value="">
                                                    <em>--Select Specialization--</em>
                                                </MenuItem>
                                                <MenuItem value="Residential">Residential</MenuItem>
                                                <MenuItem value="Commercial">Commercial</MenuItem>
                                                <MenuItem value="Luxury">Luxury Properties</MenuItem>
                                                <MenuItem value="Off-Plan">Off-Plan Projects</MenuItem>
                                                <MenuItem value="All">All Property Types</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div className="form-field">
                                        <label>Languages Spoken</label>
                                        <TextField
                                            fullWidth
                                            name="languages"
                                            value={formData.languages}
                                            onChange={handleChange}
                                            variant="outlined"
                                            placeholder="e.g., English, Arabic, Hindi, Urdu"
                                            InputProps={{
                                                placeholder: "e.g., English, Arabic, Hindi, Urdu"
                                            }}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="form-field">
                                        <label>Current Company (if any)</label>
                                        <TextField
                                            fullWidth
                                            name="currentCompany"
                                            value={formData.currentCompany}
                                            onChange={handleChange}
                                            variant="outlined"
                                            InputProps={{
                                                placeholder: "Company name or 'Freelance'"
                                            }}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="form-field">
                                        <label>RERA Number (if any)</label>
                                        <TextField
                                            fullWidth
                                            name="reraNumber"
                                            value={formData.reraNumber}
                                            onChange={handleChange}
                                            variant="outlined"
                                            InputProps={{
                                                placeholder: "RERA license number"
                                            }}
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                )}

                {step === 3 && (
                    <div className="form-step">
                        <div className="step-header">
                            <div className="step-number">3</div>
                            <h3>Required Documents</h3>
                        </div>

                        <div className="form-container">
                            <div className="document-upload">
                                <div className="document-upload-item">
                                    <label>Passport Copy <span className="required-field">*</span></label>
                                    <p className="document-help">Upload a clear copy of your passport's main page</p>
                                    <div className="upload-btn-wrapper">
                                        <div className="upload-btn">
                                            {formData.passport ? formData.passport.name : 'Choose file...'}
                                        </div>
                                        <input
                                            type="file"
                                            name="passport"
                                            onChange={handleFileChange}
                                            accept=".pdf,.jpg,.jpeg,.png"
                                        />
                                    </div>
                                </div>

                               {/* <div className="document-upload-item">
                                    <label>Resume/CV <span className="required-field">*</span></label>
                                    <p className="document-help">Upload your updated resume or CV in PDF or Word format</p>
                                    <div className="upload-btn-wrapper">
                                        <div className="upload-btn">
                                            {formData.resume ? formData.resume.name : 'Choose file...'}
                                        </div>
                                        <input
                                            type="file"
                                            name="resume"
                                            onChange={handleFileChange}
                                            accept=".pdf,.doc,.docx"
                                        />
                                    </div>
                                </div>*/}

                                <div className="document-upload-item">
                                    <label>RERA License (if available)</label>
                                    <p className="document-help">Upload your RERA license if you already have one</p>
                                    <div className="upload-btn-wrapper">
                                        <div className="upload-btn">
                                            {formData.reraLicense ? formData.reraLicense.name : 'Choose file...'}
                                        </div>
                                        <input
                                            type="file"
                                            name="reraLicense"
                                            onChange={handleFileChange}
                                            accept=".pdf,.jpg,.jpeg,.png"
                                        />
                                    </div>
                                </div>

                                <div className="document-upload-item">
                                    <label>Other Supporting Documents</label>
                                    <p className="document-help">Upload any additional certificates, references, or supporting documents</p>
                                    <div className="upload-btn-wrapper">
                                        <div className="upload-btn">
                                            {formData.otherDocuments ? formData.otherDocuments.name : 'Choose file...'}
                                        </div>
                                        <input
                                            type="file"
                                            name="otherDocuments"
                                            onChange={handleFileChange}
                                            accept=".pdf,.jpg,.jpeg,.png,.zip"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <div className="form-navigation">
                    <Button
                        className="cBtn cBtnLarge"
                        type="button"
                        onClick={handlePrevious}
                    >
                        <i className="fi ti-arrow-left"></i>
                        Previous
                    </Button>

                    {step < 3 ? (
                        <Button
                            className="cBtn cBtnLarge cBtnTheme"
                            type="button"
                            onClick={handleNext}
                        >
                            Next Step
                            <i className="fi ti-arrow-right"></i>
                        </Button>
                    ) : (
                        <Button
                            className="cBtn cBtnLarge cBtnTheme"
                            type="submit"
                            disabled={isRegistering}
                        >
                            <i className="fi flaticon-check"></i>
                            {isRegistering ? "Submitting..." : "Submit Registration"}
                        </Button>
                    )}
                </div>
            </form>
        </div>
    );
};

export default AgentRegistrationForm;
